module.exports = __webpack_public_path__ + "img/hr-train-wheels-shadow-7.23ecb9f0.png";